<template>
    <div>
      <span  v-if="value">
        <div class="selected-article">

          <div class="img" v-if="value.image" :style="{'background-image': 'url('+value.image.image+')'}"></div>
          <div class="img" v-if="!value.image" ></div>

          <div class="img-text">
              <router-link :to="{name: 'article', params: {id: value.id}}" class="ellipsis">{{value.title}}</router-link>
              <span class="ellipsis grey">{{value.publication_name}} &bullet; {{value.published_date}}</span>
          </div>

        </div>

        <a @click="clearArticleField()">Select another Article?</a>
      </span>

        <field :errors="errors" :label="label" name="name" v-if="!value">
            <input @blur="active=false" @focus="active=true" type="text" @keyup="searchArticleField()" v-model="search_value" placeholder="Search articles...">
            <div class="live-search" v-if="active">
                <div class="live-search__contents">
                    <div class="result" v-bind:key="result.id" @mousedown="clickArticleResult(result)" v-for="result in results">
                        <i class="material-icons">launch</i> {{result.title}}
                    </div>
                </div>
            </div>
        </field>

    </div>
</template>

<script>
    import Field from '@/components/Field.vue'

    export default {
        components: {
            Field,
        },
        props: [ 'help', 'label', 'value', 'articles', 'errors'],
        data () {
            return {
                search_value: '',
                results: this.articles,
                active: false,
            }
        },
        computed: {
        },
        methods: {
            setPage (page){
                this.$emit('input', '/' + page.slug + '/')
            },
            test(a){
                this.$emit('input', a.target.value)
            },
            searchArticleField (field) {
                var term = this.search_value
                if(term){
                    term = term.toLowerCase()
                    if(this.articles.length === 50){
                        this.$http.get('/articles/?search='+term).then(data => {
                            this.results = data.data
                            this.$forceUpdate();
                        })
                    }else{
                        this.results = []
                        for(var i=0; i<this.articles.length; i++){
                            if(this.articles[i].title.toLowerCase().indexOf(term) !== -1){
                                this.results.push(this.articles[i])
                            }
                        }
                        this.$forceUpdate();
                    }
                }
            },
            clearArticleField(f){
                this.$emit('input', null)
              this.search_value = ''
              this.$forceUpdate();
            },
            clickArticleResult (result) {
                this.$emit('input', result)
                this.search_value = ''
                this.results = this.articles;
              this.$forceUpdate();
            }
        },
    }
</script>
